import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Input, ViewChild, Inject } from '@angular/core';
import * as _ from 'lodash';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
 

@Component({
    selector: 'app-block-video-player',
    templateUrl: './block-video-player.component.html',
    styleUrls: ['./block-video-player.component.scss'],
    standalone: true,
    imports: [VgCoreModule]
})
export class BlockVideoPlayerComponent implements OnInit {
    @Input() provider;
    @Input() type;
    @Input() src;

    constructor(@Inject(DOCUMENT) private document: Document) {
        document = this.document;
    } 
     
  

    
   
    ngOnInit(): void {
   
    }


}
